export default {
  nanoid: {
    // See collision potential, for reference: https://zelark.github.io/nano-id-cc/
    alphabet: '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz',
    maxRetries: 5,
    length: 12,
  },
  dogDiseasesOptions: [
    { diseaseCode: 'allergies', isLimiting: false },
    { diseaseCode: 'digestive', isLimiting: false },
    { diseaseCode: 'skinProblems', isLimiting: false },
    { diseaseCode: 'jointProblems', isLimiting: false },
    { diseaseCode: 'dentalProblems', isLimiting: false },
    { diseaseCode: 'diabetes', isLimiting: false },
    { diseaseCode: 'epilepsy', isLimiting: false },
    { diseaseCode: 'otitis', isLimiting: false },
    { diseaseCode: 'cushingSyndrome', isLimiting: false },
    { diseaseCode: 'hypothyroidism', isLimiting: false },
  ],
  dogEstimatedSizes: [
    { size: 'xs', weightRange: [0, 7] },
    { size: 's', weightRange: [7, 15] },
    { size: 'm', weightRange: [15, 27] },
    { size: 'l', weightRange: [27, 47] },
    { size: 'xl', weightRange: [47, 80] },
  ],
  // Menu options
  menus: ['chicken', 'turkey', 'beef', 'salmon'],
  allowedAllergiesMenus: {
    beef: ['chicken', 'turkey', 'salmon'],
    chicken: ['turkey', 'beef', 'salmon'],
    salmon: ['chicken', 'turkey', 'beef'],
    turkey: ['chicken', 'beef', 'salmon'],
  },
  allergiesIngredients: ['gluten', 'cereals', 'dairy', 'eggs', 'beef', 'chicken', 'turkey', 'salmon', 'soya'],
  menusInfo: {
    turkey: {
      ingredients: [
        { label: 'turkey', icon: 'ingredient-turkey', percentage: 60.7 },
        { label: 'carrot', icon: 'ingredient-carrot', percentage: 23.8 },
        { label: 'sweetPotato', icon: 'ingredient-sweet-potato', percentage: 5.5 },
        { label: 'oil', icon: 'ingredient-sunflower-oil', percentage: 2.1 },
        { label: 'turnip', icon: 'ingredient-turnip', percentage: 1.8 },
        { label: 'peas', icon: 'ingredient-peas', percentage: 1.8 },
        { label: 'zucchini', icon: 'ingredient-zucchini', percentage: 1.8 },
        { label: 'starch', icon: 'ingredient-starch', percentage: 1.8 },
        { label: 'apple', icon: 'ingredient-apple', percentage: 0.5 },
        { label: 'minerals', icon: 'ingredient-minerals', percentage: 0.2 },
      ],
      analyticalComponents: [
        { label: 'humidity', value: 69 },
        { label: 'protein', value: 12 },
        { label: 'fat', value: 12 },
        { label: 'fiber', value: 2 },
        { label: 'ashes', value: 2.8 },
        { label: 'carbohydrate', value: 2.2 },
      ],
      dryAnalyticalComponents: [
        { label: 'protein', value: 38.7 },
        { label: 'fat', value: 38.7 },
        { label: 'fiber', value: 2 },
        { label: 'ashes', value: 9 },
        { label: 'carbohydrate', value: 2.2 },
      ],
      nutritionalAdditives: {
        vitamins: [
          { label: 'vitaminA', quantity: '22500 UI/kg' },
          { label: 'vitaminD', quantity: '1875 UI/kg' },
          { label: 'vitaminE', quantity: '67.5 mg/kg' },
        ],
        traceElements: [
          { label: 'iron', quantity: '60 mg/kg' },
          { label: 'copper', quantity: '4 mg/kg' },
          { label: 'manganesium', quantity: '15 mg/kg' },
          { label: 'zinc', quantity: '60 mg/kg' },
          { label: 'potassiumIodide', quantity: '1 mg/kg' },
          { label: 'selenium', quantity: '0,10 mg/kg' },
          { label: 'chloride', quantity: '39 mg/kg' },
          { label: 'calpan', quantity: '41 mg/kg' },
        ],
      },
      humidity: 69,
      tagElements: ['preservativesFree', 'cerealsFree', 'frozen'],
      menuBgImage: {
        desktop: '/images/menus/menu-pavo-dogfy-diet-desktop.jpg',
        mobile: '/images/menus/menu-pavo-dogfy-diet-mobile.jpg',
      },
      menuBgImageCard: '/images/menus/seleccion-menu-pavo.jpg',
      title: 'Turkey menu',
    },
    salmon: {
      ingredients: [
        { label: 'salmon', icon: 'ingredient-salmon', percentage: 60.3 },
        { label: 'carrot', icon: 'ingredient-carrot', percentage: 26.5 },
        { label: 'potato', icon: 'ingredient-potato', percentage: 7.3 },
        { label: 'turnip', icon: 'ingredient-turnip', percentage: 2.7 },
        { label: 'starch', icon: 'ingredient-starch', percentage: 1.8 },
        { label: 'minerals', icon: 'ingredient-minerals', percentage: 0.7 },
        { label: 'vegetableOil', icon: 'ingredient-sunflower-oil', percentage: 0.7 },
      ],
      analyticalComponents: [
        { label: 'humidity', value: 69 },
        { label: 'protein', value: 12.3 },
        { label: 'fat', value: 11.5 },
        { label: 'fiber', value: 1.5 },
        { label: 'ashes', value: 1.6 },
        { label: 'carbohydrate', value: 4.1 },
      ],
      dryAnalyticalComponents: [
        { label: 'protein', value: 39.7 },
        { label: 'fat', value: 37 },
        { label: 'fiber', value: 4.8 },
        { label: 'ashes', value: 5.2 },
        { label: 'carbohydrate', value: 13.3 },
      ],
      nutritionalAdditives: {
        vitamins: [
          { label: 'vitaminA', quantity: '22500 UI/kg' },
          { label: 'vitaminD', quantity: '1875 UI/kg' },
          { label: 'vitaminE', quantity: '67.5 mg/kg' },
        ],
        traceElements: [
          { label: 'iron', quantity: '60 mg/kg' },
          { label: 'copper', quantity: '4 mg/kg' },
          { label: 'manganesium', quantity: '15 mg/kg' },
          { label: 'zinc', quantity: '60 mg/kg' },
          { label: 'potassiumIodide', quantity: '1 mg/kg' },
          { label: 'selenium', quantity: '0,10 mg/kg' },
          { label: 'chloride', quantity: '39 mg/kg' },
          { label: 'calpan', quantity: '41 mg/kg' },
        ],
      },
      humidity: 69,
      tagElements: ['preservativesFree', 'cerealsFree', 'frozen'],
      menuBgImage: {
        desktop: '/images/menus/menu-salmon-dogfy-diet-desktop.jpg',
        mobile: '/images/menus/menu-salmon-dogfy-diet-mobile.jpg',
      },
      menuBgImageCard: '/images/menus/seleccion-menu-salmon.jpg',
      title: 'Salmon menu',
    },
    chicken: {
      ingredients: [
        { label: 'chicken', icon: 'ingredient-chicken', percentage: 61.4 },
        { label: 'carrot', icon: 'ingredient-carrot', percentage: 23.8 },
        { label: 'potato', icon: 'ingredient-potato', percentage: 5.5 },
        { label: 'pumpkin', icon: 'ingredient-pumpkin', percentage: 3.7 },
        { label: 'peas', icon: 'ingredient-peas', percentage: 1.8 },
        { label: 'starch', icon: 'ingredient-starch', percentage: 1.8 },
        { label: 'oil', icon: 'ingredient-sunflower-oil', percentage: 1.3 },
        { label: 'apple', icon: 'ingredient-apple', percentage: 0.5 },
        { label: 'minerals', icon: 'ingredient-minerals', percentage: 0.2 },
      ],
      analyticalComponents: [
        { label: 'humidity', value: 69 },
        { label: 'protein', value: 13 },
        { label: 'fat', value: 12 },
        { label: 'fiber', value: 2 },
        { label: 'ashes', value: 2 },
        { label: 'carbohydrate', value: 2 },
      ],
      dryAnalyticalComponents: [
        { label: 'protein', value: 42 },
        { label: 'fat', value: 38.7 },
        { label: 'fiber', value: 2 },
        { label: 'ashes', value: 6.4 },
        { label: 'carbohydrate', value: 2 },
      ],
      nutritionalAdditives: {
        vitamins: [
          { label: 'vitaminA', quantity: '22500 UI/kg' },
          { label: 'vitaminD', quantity: '1875 UI/kg' },
          { label: 'vitaminE', quantity: '67.5 mg/kg' },
        ],
        traceElements: [
          { label: 'iron', quantity: '60 mg/kg' },
          { label: 'copper', quantity: '4 mg/kg' },
          { label: 'manganesium', quantity: '15 mg/kg' },
          { label: 'zinc', quantity: '60 mg/kg' },
          { label: 'potassiumIodide', quantity: '1 mg/kg' },
          { label: 'selenium', quantity: '0,10 mg/kg' },
          { label: 'chloride', quantity: '39 mg/kg' },
          { label: 'calpan', quantity: '41 mg/kg' },
        ],
      },
      humidity: 69,
      tagElements: ['preservativesFree', 'cerealsFree', 'frozen'],
      menuBgImage: {
        desktop: '/images/menus/menu-pollo-dogfy-diet-desktop.jpg',
        mobile: '/images/menus/menu-pollo-dogfy-diet-mobile.jpg',
      },
      menuBgImageCard: '/images/menus/seleccion-menu-pollo.jpg',
      title: 'Chicken menu',
    },
    beef: {
      ingredients: [
        { label: 'beef', icon: 'ingredient-beef', percentage: 65.3 },
        { label: 'carrot', icon: 'ingredient-carrot', percentage: 25.2 },
        { label: 'potato', icon: 'ingredient-potato', percentage: 3.7 },
        { label: 'sweetPotato', icon: 'ingredient-sweet-potato', percentage: 1.9 },
        { label: 'oil', icon: 'ingredient-sunflower-oil', percentage: 1.7 },
        { label: 'minerals', icon: 'ingredient-minerals', percentage: 1.2 },
        { label: 'starch', icon: 'ingredient-starch', percentage: 1 },
      ],
      analyticalComponents: [
        { label: 'humidity', value: 72 },
        { label: 'protein', value: 12 },
        { label: 'fat', value: 10.5 },
        { label: 'fiber', value: 1.3 },
        { label: 'ashes', value: 1.2 },
        { label: 'carbohydrate', value: 3 },
      ],
      dryAnalyticalComponents: [
        { label: 'protein', value: 42.9 },
        { label: 'fat', value: 37.5 },
        { label: 'fiber', value: 4.6 },
        { label: 'ashes', value: 4.3 },
        { label: 'carbohydrate', value: 10.7 },
      ],
      nutritionalAdditives: {
        vitamins: [
          { label: 'vitaminA', quantity: '22500 UI/kg' },
          { label: 'vitaminD', quantity: '1875 UI/kg' },
          { label: 'vitaminE', quantity: '67.5 mg/kg' },
        ],
        traceElements: [
          { label: 'iron', quantity: '60 mg/kg' },
          { label: 'copper', quantity: '4 mg/kg' },
          { label: 'manganesium', quantity: '15 mg/kg' },
          { label: 'zinc', quantity: '60 mg/kg' },
          { label: 'potassiumIodide', quantity: '1 mg/kg' },
          { label: 'selenium', quantity: '0,10 mg/kg' },
          { label: 'chloride', quantity: '39 mg/kg' },
          { label: 'calpan', quantity: '41 mg/kg' },
        ],
      },
      humidity: 72,
      tagElements: ['preservativesFree', 'cerealsFree', 'frozen'],
      menuBgImage: {
        desktop: '/images/menus/menu-buey-dogfy-diet-desktop.jpg',
        mobile: '/images/menus/menu-buey-dogfy-diet-mobile.jpg',
      },
      menuBgImageCard: '/images/menus/seleccion-menu-buey.jpg',
      title: 'Beef menu',
    },
  },
  menusURL: {
    production: {
      es: {
        fileName: 'Informacion nutricional - Español.pdf (986kB)',
        fileUrl: 'https://storage.googleapis.com/public-files-dogfy/es/Informacion_Nutricional.pdf',
      },
      fr: {
        fileName: 'Information nutritionnelle - Français.pdf (975kB)',
        fileUrl: 'https://storage.googleapis.com/public-files-dogfy/fr/Information_Nutritionnelle.pdf',
      },
      it: {
        fileName: 'Informazione nutrizionale - Italiano.pdf (973kB)',
        fileUrl: 'https://storage.googleapis.com/public-files-dogfy/it/Informazione_Nutrizionale.pdf',
      },
    },
    staging: {
      es: {
        fileName: 'Informacion nutricional - Español.pdf (986kB)',
        fileUrl: 'https://storage.googleapis.com/staging-public-files-dogfy/es/Informacion_Nutricional.pdf',
      },
      fr: {
        fileName: 'Information nutritionnelle - Français.pdf (975kB)',
        fileUrl: 'https://storage.googleapis.com/staging-public-files-dogfy/fr/Information_Nutritionnelle.pdf',
      },
      it: {
        fileName: 'Informazione nutrizionale - Italiano.pdf (973kB)',
        fileUrl: 'https://storage.googleapis.com/staging-public-files-dogfy/it/Informazione_Nutrizionale.pdf',
      },
    },
    development: {
      es: {
        fileName: 'Informacion nutricional - Español.pdf (986kB)',
        fileUrl: 'https://storage.googleapis.com/staging-public-files-dogfy/es/Informacion_Nutricional.pdf',
      },
      fr: {
        fileName: 'Information nutritionnelle - Français.pdf (975kB)',
        fileUrl: 'https://storage.googleapis.com/staging-public-files-dogfy/fr/Information_Nutritionnelle.pdf',
      },
      it: {
        fileName: 'Informazione nutrizionale - Italiano.pdf (973kB)',
        fileUrl: 'https://storage.googleapis.com/staging-public-files-dogfy/it/Informazione_Nutrizionale.pdf',
      },
    },
  },
  // If the list of updatable extras is expanded, ensure to include availability in the database.
  editableExtras: ['snacks'],
  extras: {
    snacks: {
      lamb: {
        formats: [
          {
            format: '70g',
            price: {
              es: 3.69,
              fr: 3.99,
              it: 3.99,
            },
          },
          {
            format: '150g',
            price: {
              es: 5.99,
              fr: 6.99,
              it: 6.99,
            },
          },
        ],
        label: 'snackLamb',
        images: ['snack_lamb_01.jpg', 'snack_lamb_02.jpg', 'snack_lamb_03.jpg', 'snack_lamb_04.jpg', 'snack_lamb_05.jpg'],
        emojis: '🏋️‍♂️',
        hasSticker: true,
        tags: ['natural'],
        ingredients: [
          { label: 'lamb', percentage: 60 },
          { label: 'driedSweetPotato' },
          { label: 'glycerol' },
          { label: 'driedPotato' },
          { label: 'herbs', percentage: 1 },
        ],
        analyticalComponents: [
          { label: 'humidity', percentage: 24.3 },
          { label: 'protein', percentage: 16.6 },
          { label: 'fat', percentage: 12.6 },
          { label: 'fiber', percentage: 1.4 },
          { label: 'ashes', percentage: 3.3 },
        ],
        nutritionalAdditives: ['citricAcid'],
      },
      beef: {
        formats: [
          {
            format: '70g',
            price: {
              es: 3.69,
              fr: 3.99,
              it: 3.99,
            },
          },
          {
            format: '150g',
            price: {
              es: 5.99,
              fr: 6.99,
              it: 6.99,
            },
          },
        ],
        label: 'snackBeef',
        images: ['snack_beef_01.jpg', 'snack_beef_02.jpg', 'snack_beef_03.jpg', 'snack_beef_04.jpg', 'snack_beef_05.jpg'],
        emojis: '💪',
        hasSticker: true,
        tags: ['natural'],
        ingredients: [
          { label: 'beef', percentage: 60 },
          { label: 'driedSweetPotato' },
          { label: 'glycerol' },
          { label: 'driedPotato' },
          { label: 'herbs', percentage: 1 },
        ],
        analyticalComponents: [
          { label: 'humidity', percentage: 20.7 },
          { label: 'protein', percentage: 17 },
          { label: 'fat', percentage: 15.1 },
          { label: 'fiber', percentage: 1.4 },
          { label: 'ashes', percentage: 3.7 },
        ],
        nutritionalAdditives: ['citricAcid'],
      },
      salmon: {
        formats: [
          {
            format: '70g',
            price: {
              es: 3.69,
              fr: 3.99,
              it: 3.99,
            },
          },
          {
            format: '150g',
            price: {
              es: 5.99,
              fr: 6.99,
              it: 6.99,
            },
          },
        ],
        label: 'snackSalmon',
        images: ['snack_salmon_01.jpg', 'snack_salmon_02.jpg', 'snack_salmon_03.jpg', 'snack_salmon_04.jpg', 'snack_salmon_05.jpg'],
        emojis: '🧠',
        hasSticker: true,
        tags: ['natural'],
        ingredients: [
          { label: 'salmon', percentage: 60 },
          { label: 'driedSweetPotato' },
          { label: 'glycerol' },
          { label: 'driedPotato' },
          { label: 'herbs', percentage: 1 },
        ],
        analyticalComponents: [
          { label: 'humidity', percentage: 26 },
          { label: 'protein', percentage: 18.3 },
          { label: 'fat', percentage: 11 },
          { label: 'fiber', percentage: 0.7 },
          { label: 'ashes', percentage: 3.2 },
        ],
        nutritionalAdditives: ['citricAcid'],
      },
    },
    accessories: {
      ball: {
        formats: [
          {
            format: 'standard',
            price: {
              es: 0,
              fr: 0,
              it: 0,
            },
          },
        ],
        label: 'ball',
      },
      bandana: {
        formats: [
          {
            format: 'standard',
            price: {
              es: 0,
              fr: 0,
              it: 0,
            },
          },
        ],
        label: 'bandana',
      },
      fridge: {
        formats: [
          {
            format: 'standard',
            price: {
              es: 0,
              fr: 0,
              it: 0,
            },
          },
        ],
        label: 'fridge',
      },
    },
  },
  unservedRegions: {
    es: ['07', '35', '38', '51', '52'],
    fr: ['20', '973', '974', '975', '976', '984', '986', '987', '988', '17123', '22870', '29242', '29253', '29259', '29990', '56360', '56590', '56780', '56840', '85350', '83400'],
    it: ['07', '08', '09', '75', '85', '87', '88', '89', '90', '91', '92', '93', '94', '95', '96', '97', '98', '13010', '13019', '13020', '13021', '13022', '13024', '13025', '13026', '13027', '13028', '13029', '22061', '23041', '33027', '33029', '33090', '57030', '57031', '57032', '57033', '57034', '57036', '57037', '57038', '57039', '58012', '58019', '66030', '66031', '66033', '66040', '66042', '66044', '66045', '66046', '66047', '66050', '67013', '67014', '67015', '67020', '67022', '67023', '67024', '67025', '67029', '67030', '67032', '67045', '67049', '67050', '67055', '67057', '67058', '67064', '67066', '72012', '72013', '72014', '72015', '72017', '72018', '72019', '72020', '72021', '72022', '72023', '72024', '72025', '72026', '72027', '72028', '72029', '72100', '73010', '73011', '73012', '73013', '73014', '73015', '73016', '73017', '73018', '73019', '73020', '73021', '73022', '73023', '73024', '73025', '73026', '73027', '73028', '73029', '73030', '73031', '73032', '73033', '73034', '73035', '73036', '73037', '73038', '73039', '73040', '73041', '73042', '73043', '73044', '73045', '73046', '73047', '73048', '73049', '73050', '73051', '73052', '73053', '73054', '73055', '73056', '73057', '73058', '73059', '73100', '74010', '74011', '74012', '74013', '74014', '74015', '74016', '74017', '74018', '74019', '74020', '74021', '74022', '74023', '74024', '74025', '74026', '74027', '74028', '74100', '74121', '74122', '74123', '80051', '80060', '80061', '80062', '80063', '80065', '80066', '80067', '80069', '80071', '80072', '80073', '80074', '80075', '80076', '80077', '80079', '80081', '82010', '82011', '82013', '82014', '82015', '82016', '82017', '82018', '82019', '82020', '82021', '82022', '82023', '82024', '82025', '82026', '82027', '82028', '82029', '82030', '82031', '82032', '82033', '82034', '82036', '82037', '82038', '83010', '83011', '83012', '83013', '83014', '83015', '83016', '83017', '83018', '83020', '83021', '83022', '83023', '83024', '83025', '83027', '83028', '83029', '83030', '83031', '83032', '83034', '83035', '83036', '83037', '83038', '83039', '83040', '83041', '83042', '83043', '83044', '83045', '83046', '83047', '83048', '83049', '83050', '83051', '83052', '83053', '83054', '83055', '83056', '83057', '83058', '83059', '84090', '84091', '84092', '84095', '84096', '84098', '86010', '86011', '86012', '86013', '86014', '86015', '86016', '86017', '86018', '86019', '86020', '86021', '86022', '86023', '86024', '86026', '86027', '86028', '86029', '86030', '86031', '86032', '86033', '86034', '86035', '86037', '86040', '86041', '86042', '86043', '86044', '86045', '86046', '86047', '86048', '86049', '86070', '86071', '86072', '86073', '86074', '86075', '86077', '86078', '86079', '86080', '86081', '86082', '86083', '86084', '86085', '86086', '86087', '86088', '86089', '86090', '86091', '86092', '86093', '86094', '86095', '86096', '86097', '86170', '02010', '02011', '02012', '02013', '02019', '02021', '02022', '02023', '02024', '02025', '02030', '02035', '04027', '04031'],
  },
  emailDomainWhitelist: {
    gmail: ['com'],
    hotmail: ['es', 'it', 'fr', 'de', 'pt', 'be', 'co', 'uk', 'ar', 'dk', 'mx', 'br', 'com'],
    icloud: ['com'],
    msn: ['com'],
    outlook: ['es', 'fr', 'it', 'de', 'pt', 'be', 'co', 'uk', 'ar', 'dk', 'mx', 'br', 'com'],
    yahoo: ['es', 'fr', 'it', 'de', 'pt', 'be', 'co', 'uk', 'ar', 'dk', 'mx', 'br', 'com'],
  },
  countryOptions: [
    { label: 'common.label.country.es', value: 'es' },
    { label: 'common.label.country.fr', value: 'fr' },
    { label: 'common.label.country.it', value: 'it' },
  ],
  servedCountries: ['es', 'fr', 'it'],
  allowedTrialDeliveryWeekDays: {
    es: [2, 3, 4, 5],
    fr: [3, 5, 6],
    it: [2, 3, 4, 5],
  },
  visibleDaysPerWeek: {
    es: 5,
    it: 5,
    fr: 6,
  },
  countryIcons: {
    es: {
      cards: ['visa', 'mastercard', 'amex'],
      shipment: ['gls'],
      payment: ['stripe'],
    },
    fr: {
      cards: ['visa', 'mastercard', 'amex', 'paypal'],
      shipment: ['chronofresh'],
      payment: ['stripe', 'ssl'],
    },
    it: {
      cards: ['visa', 'mastercard', 'amex', 'paypal'],
      shipment: ['brt', 'gls'],
      payment: ['stripe'],
    },
  },
  defaultTrialDiscountPercent: {
    es: 0.3,
    fr: 0.5,
    it: 0.3,
  },
  defaultReferralDiscountPercent: 0.2,
  deliveryDeltaDays: {
    payment: {
      es: 3,
      fr: 4,
      it: 2,
    },
    processing: {
      es: 2,
      fr: 3,
      it: 1,
    },
    sent: {
      es: 1,
      fr: 3,
      it: 1,
    },
  },
  paymentsCutoffHour: 17,
  paymentMethods: {
    es: ['card', 'paypal'],
    fr: ['card', 'paypal'],
    it: ['card', 'paypal'],
  },
  dogfyContacts: {
    es: {
      nutritionists: {
        email: 'nutricionistas@dogfydiet.com',
        phone: '',
        url: 'https://sos.dogfydiet.com/hc/es/requests/new?ticket_form_id=15091879478300',
      },
      customerService: {
        email: 'atc@dogfydiet.com',
        phone: '+34919012562',
        whatsApp: '34604101010',
        url: 'https://sos.dogfydiet.com/hc/es/requests/new?ticket_form_id=7376541657756',
      },
      sales: {
        email: '',
        phone: '+33745882205',
        whatsApp: '34613177874',
      },
      whistleblowingUrl: 'https://dogfydiet.integrityline.com',
    },
    fr: {
      nutritionists: {
        email: 'sav@dogfydiet.com',
        phone: '',
        url: '',
      },
      customerService: {
        email: 'sav@dogfydiet.com',
        phone: '+33644602195',
        whatsApp: '33644602195',
        url: 'https://sos.dogfydiet.com/hc/fr/requests/new?ticket_form_id=7376541657756',
      },
      sales: {
        email: '',
        phone: '+33745882205',
        whatsApp: '',
      },
      whistleblowingUrl: '',
    },
    it: {
      nutritionists: {
        email: 'nutrizionisti@dogfydiet.com',
        phone: '',
        url: 'https://sos.dogfydiet.com/hc/it/requests/new?ticket_form_id=15091879478300',
      },
      customerService: {
        email: 'clienti@dogfydiet.com',
        phone: '+390699310034',
        whatsApp: '390281481048',
        url: 'https://sos.dogfydiet.com/hc/it/requests/new?ticket_form_id=7376541657756',
      },
      sales: {
        email: '',
        phone: '+33745882205',
        whatsApp: '',
      },
      whistleblowingUrl: '',
    },
  },
  planOptions: ['standard', 'mixed'],
  mixedPlanAllowedCountriesWhenPausing: ['es', 'fr', 'it'],
  mixedPlanAllowedCountries: ['fr', 'it'],
  breakpoints: {
    xxl: 2560,
    xl: 1366,
    lg: 1024,
    md: 768,
    sm: 480,
  },
  coupons: {
    // Apart from the below, there are referral coupons with structure: (Ex: "CUSTOMER-509").
    code: {
      P: {
        isSubscriptionOnly: true, // Applies to subscription only.
      },
      S: {
        isLifetime: true, // Applies to trial, first renewal, and subscription.
      },
      X: {
        isSingleTime: true, // Applies to one renovation only, after that it is deleted.
      },
      E: {
        expiresInMinutes: 30, // Can only be applied within 30 min after the lead creation.
      },
      F: {
        expiresInMinutes: 3 * 60 * 24, // Can only be applied within 3 days after the lead creation.
      },
      G: {
        expiresInMinutes: 12 * 60 * 24, // Can only be applied within 12 days after the lead creation.
      },
    },
  },
  minMonthlyPrice: {
    es: 21.90,
    fr: 26.65,
    it: 26.32,
  },
  halfBagGrammages: [50, 150, 250],
  socialMediaLinks: {
    tiktok: {
      icon: 'tiktok',
      company: 'Tik Tok',
      url: { es: 'https://tiktok.com/@dogfy.diet', fr: 'https://tiktok.com/@dogfydiet.fr', it: 'https://tiktok.com/@dogfydiet.it' },
    },
    instagram: {
      icon: 'instagram',
      company: 'Instagram',
      url: { es: 'https://instagram.com/dogfydiet', fr: 'https://instagram.com/dogfydiet.fr', it: 'https://instagram.com/dogfydiet.it' },
    },
    facebook: {
      icon: 'facebook',
      company: 'Facebook',
      url: { es: 'https://facebook.com/dogfydiet', fr: 'https://facebook.com/dogfydiet.fr', it: 'https://facebook.com/Dogfy-Diet-Italia-106293285355475' },
    },
    youtube: {
      icon: 'youtube',
      company: 'Youtube',
      url: { es: 'https://www.youtube.com/@dogfydiet', fr: 'https://www.youtube.com/@dogfydietfrance' },
    },
  },
  cookies: {
    excludedPaths: ['/privacidad', '/fr/privacite', '/it/privacy'],
    acquisition: {
      key: 'acquisition',
      expires: 3600 * 24 * 7, // 7 days.
    },
    consent: {
      key: 'consent',
      expires: 3600 * 24 * 182, // 182 days.
      types: {
        needed: ['functionality'],
        security: ['security'],
        statistics: ['analytics'],
        marketing: ['ad', 'personalization'],
      },
    },
    locale: {
      key: 'locale',
      expires: 3600 * 24 * 365, // 1 year.
      sameSite: 'lax',
    },
  },
  dogWeight: {
    min: 1,
    max: 80,
    maxDecimals: 2,
  },
  // By Stripe rule, the minimum limit of charging is 0.50€. https://docs.stripe.com/api/charges/object
  minStripeCharge: 0.5,
}
